import { isEmpty } from '@ember/utils';
import dateUtils from 'donor-elf-web/lib/date-utils';
import { assignSingleProperty } from 'donor-elf-web/lib/object-utils';

export default {
  startDate: (key, newValue, oldValue, changes, content) => {
    if (isEmpty(newValue)) {
      return "Start Date can't be blank";
    }
    if (
      dateUtils.serializeToDateOnly(newValue) >
      dateUtils.serializeToDateOnly(new Date())
    ) {
      return "Start Date can't be in the future";
    }
    let goalDate = assignSingleProperty(content, changes, 'goalDate');
    if (goalDate && goalDate <= newValue) {
      return 'Start Date has to be before Goal Date';
    }
    return true;
  },
  goalDate: (key, newValue, oldValue, changes, content) => {
    if (isEmpty(newValue)) {
      return "Goal Date can't be blank";
    }
    return true;
  },
  closedDate: (key, newValue, oldValue, changes, content) => {
    if (isEmpty(newValue)) {
      return true;
    }
    let startDate = assignSingleProperty(content, changes, 'startDate');
    if (startDate >= newValue) {
      return 'Closed Date has to be after Start Date';
    }
    return true;
  },
};
